export default __webpack_public_path__ + "static/media/check.ad660bd9.svg";